import React from "react";

import { RankedTableDataProps } from "components/ranked-table/types";

import DesktopChart from "../../../ranked-table/desktop-chart";
import MobileChart from "../../../ranked-table/mobile-chart";
import { defaultLendersList, defaultLendingFeatures } from "./features";

const chartTitle = "Integrated Lenders";

type LenderFeaturesChartProps = RankedTableDataProps & {
  className?: string;
};
const LenderFeaturesChart = ({
  features: lendingFeatures,
  integratorsList: lenders,
  ...rest
}: LenderFeaturesChartProps) => {
  const loadedData = !!lendingFeatures?.length && !!lenders?.length;
  const chartProps = {
    features: loadedData ? lendingFeatures : defaultLendingFeatures,
    integratorsList: loadedData ? lenders : defaultLendersList,
  };
  return (
    <>
      <DesktopChart title={chartTitle} {...chartProps} {...rest} />
      <MobileChart title={chartTitle} {...chartProps} {...rest} />
    </>
  );
};

export default LenderFeaturesChart;
